import { useEquipmentCatalog } from '@/util/useEquipmentCatalog';
import { decodeEquipmentSerial, type SerialDecode } from '@rock/serials';
import type { Equipment } from '@rock/types';
import { todayLocalDate } from '@rock/util';
import { useMemo } from 'react';

/**
 * Decode the equipment's serial number into manufacture-date info. Undefined whenever the brand
 * has no decoder or the serial doesn't parse — callers render nothing in that case (the decode
 * surfaces are opportunistic, never an empty/error state).
 *
 * Admin twin of the app's `useSerialDecode` — the input assembly lives in `decodeEquipmentSerial`
 * (the two surfaces may only differ in brand RESOLUTION); here the brand comes via the matched
 * model's `brandId`, through `useEquipmentCatalog`. The app additionally falls back to a
 * `brand-aliases/{key}` lookup for model-less equipment; skipped here until it earns its keep.
 */
export function useSerialDecode(equipment: Equipment): SerialDecode | undefined {
    const { brand } = useEquipmentCatalog(equipment);
    return useMemo(() => decodeEquipmentSerial(equipment, brand, todayLocalDate()), [equipment, brand]);
}
